import { CURRENCY_SYMBOL } from "utils/constants";
import { costToFrench } from "utils/helpers/values";

const Card = ({
  insurancePlan,
  cost,
  currency,
  translation,
  addLinks,
  index,
}) => {
  const monthlyCost = costToFrench(cost);
  const annualCost = costToFrench(cost * 12);
  const currencySymbol = CURRENCY_SYMBOL[currency] || CURRENCY_SYMBOL.EUR;

  return (
    <div className="quote-template-miltis__formula">
      <div className="quote-template-miltis__formula--name">
        {insurancePlan?.name || `Formule ${index + 1}`}
      </div>
      <div className="quote-template-miltis__formula--price">
        <div className="quote-template-miltis__formula--price__monthly">
          {monthlyCost} {currencySymbol} {translation.PER_MONTH}
        </div>
        <div className="quote-template-miltis__formula--price__annual">
          {annualCost} {currencySymbol} {translation.PER_YEAR}
        </div>
      </div>
      {addLinks ? (
        <div className="quote-template-miltis__formula--button">
          {translation.LINK}
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
};

export default Card;
